import React, {useState, useEffect} from 'react';

let setPlayerState: ((s: any) => void) | null = null;

// API to open/close the global player from anywhere (no-op: global player removed)
export function openGlobalPlayer(videoId: string, options?: any) {
  if (!videoId) {
    console.warn('openGlobalPlayer called with invalid videoId:', videoId, options);
    return;
  }
  setPlayerState && setPlayerState({videoId, options, visible: true});
}
export function closeGlobalPlayer() {
  setPlayerState && setPlayerState({visible: false});
}

export const GlobalPlayerManager: React.FC = () => {
  const [, setState] = useState<{
    visible: boolean;
    videoId?: string;
    options?: any;
  }>({visible: false, videoId: undefined, options: {}});

  useEffect(() => {
    setPlayerState = setState;
    return () => {
      setPlayerState = null;
    };
  }, []);

  return null;
};
